import cartIcon from "./component-library162.mjs";
import LinkButton from "./component-library3.mjs";
import "./component-library163.mjs";
import normalizeComponent from "./component-library82.mjs";
const _sfc_main = {
  name: "AddToCartButton",
  components: {
    LinkButton,
    cartIcon
  },
  props: {
    buttonTitle: {
      type: String,
      default: "Artikel in den Warenkorb legen"
    },
    buttonText: {
      type: String,
      default: "In den Warenkorb"
    },
    displayIcon: {
      type: Boolean,
      default: false
    },
    displayText: {
      type: Boolean,
      default: true
    },
    tealiumSuffix: {
      type: String,
      default: null
    },
    theme: {
      type: String,
      default: "primary",
      validator(value) {
        return ["primary", "light", "default"].includes(value);
      }
    },
    disabled: {
      type: Boolean
    }
  },
  emits: ["add-to-cart"],
  data() {
    return {
      cartIcon
    };
  },
  computed: {
    classContainer() {
      const returnClasses = [];
      if (this.displayText)
        returnClasses.push("add-to-cart-button--has-label");
      return returnClasses.join(" ");
    }
  },
  methods: {
    emitAddToCart(e) {
      e.preventDefault();
      this.$emit("add-to-cart", e);
    }
  }
};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  return _c("LinkButton", { ref: "button", staticClass: "add-to-cart-button", class: _vm.classContainer, attrs: { "tag": "button", "disabled": _vm.disabled, "tealium-name": _vm.buttonText, "tealium-suffix": _vm.tealiumSuffix, "aria-label": _vm.buttonTitle, "primary": _vm.theme === "primary", "transparent-light": _vm.theme === "light", "small-padding": "" }, on: { "click": _vm.emitAddToCart } }, [_vm._t("badge"), _vm.displayIcon ? _c("cartIcon", { staticClass: "add-to-cart-button__icon", class: `add-to-cart-button__icon--${_vm.theme}` }) : _vm._e(), _vm.displayText ? _c("span", { staticClass: "add-to-cart-button__text" }, [_vm._t("default", function() {
    return [_vm._v(_vm._s(_vm.buttonText))];
  })], 2) : _vm._e()], 2);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "7d30a5bd",
  null,
  null
);
const AddToCartButton = __component__.exports;
export {
  AddToCartButton as default
};
